// @flow
import React, { type Node } from "react";
import { Form, Popup, Icon } from "semantic-ui-react";
import classnames from "classnames";

import Styles from "./FormLabelWithDivider.module.scss";

type Props = {|
  width?: number,
  id?: string,
  htmlFor?: string,
  title?: string | Node,
  subTitle?: string | Node,
  tooltip?: ?string,
  centered?: boolean,
  divider?: boolean,
  desktop?: boolean,
  leftAlign?: boolean,
  rightAlign?: boolean,
  themed?: boolean,
  largeIcons?: boolean,
  above?: boolean,
  inline?: boolean,
  secondary?: boolean,
  className?: string,
|};

export function FormLabelWithDivider(props: Props) {
  const {
    width = 6,
    id,
    htmlFor,
    title,
    subTitle,
    tooltip,
    centered,
    leftAlign,
    rightAlign,
    desktop,
    divider,
    themed,
    above,
    largeIcons,
    inline,
    secondary,
    className,
  } = props;
  return (
    <Form.Field
      width={width}
      className={classnames(
        {
          [Styles.centered]: centered,
          [Styles.leftAlign]: leftAlign,
          [Styles.rightAlign]: rightAlign,
          [Styles.divided]: divider,
          [Styles.aboveField]: above,
          [Styles.container]: true,
          [Styles.inline]: inline,
        },
        className
      )}
    >
      <label
        id={id}
        htmlFor={htmlFor}
        className={classnames({
          [Styles.label]: !desktop,
          [Styles.above]: above,
          [Styles.forLargeIcons]: largeIcons,
          [Styles.desktop_label]: desktop,
          "cs-customer-themed": themed,
          [Styles.inline]: inline,
        })}
      >
        {title}
        {subTitle && (
          <>
            <br />
            <br />
            {desktop ? <span className={Styles["subTitle"]}>{subTitle}</span> : subTitle}
          </>
        )}
      </label>
      {tooltip && (
        <Popup
          trigger={
            <Icon
              name="info circle"
              size={!secondary ? "large" : undefined}
              color={secondary ? "grey" : undefined}
              className={secondary ? Styles.popup : ""}
            />
          }
          wide
          content={tooltip}
          className={Styles.tooltip}
          position="top center"
          on={["click", "hover", "focus"]}
        />
      )}
    </Form.Field>
  );
}

export default FormLabelWithDivider;
